import Mustache from "Mustache";
import "whatwg-fetch";

const displayDynamicContent = (function () {
	/**
	 * Variables for _init
	 */
	let template;
	let container;
	let baseUrl;

	/**
	 * Variables for _get function
	 */
	let category;
	let hasBeenFetched = false;
	let isFetching = false;
	let apiData;

	const _init = function () {
		template = document.getElementById("dynamic-content").innerHTML;
		Mustache.parse(template);
		container = document.getElementById("template-container");
		baseUrl = "/api/?action=channel_feed";
	};

	const _get = function (slug) {
		/**
		 * Set local variables
		 */
		category = slug;

		if (!hasBeenFetched && !isFetching) {
			isFetching = true;
			getData();
		} else if (hasBeenFetched && !isFetching) {
			setTemplate(apiData.data, category);
		}
	};

	const getData = function () {
		container.classList.add("is-loading");
		const data = fetch(baseUrl, {
			method: "get",
			credentials: "same-origin",
		})
			.then((res) => res.json())
			.then((data) => {
				apiData = data;
				container.classList.remove("is-loading");
				hasBeenFetched = true;
				isFetching = false;
				setTemplate(data.data, category);
			});
	};

	const setTemplate = function (data, slug) {
		const item = data[slug];
		const html = Mustache.render(template, data[slug]);
		container.innerHTML = html;
	};

	return {
		init: _init,
		get: _get,
	};
})();

if (document.getElementById("dynamic-content")) {
	displayDynamicContent.init();
}

export default displayDynamicContent;
